import { HStack } from '@cdl/heartbeat-react';
import { TagFilter } from '../../plot/components/TagFilter';
import { LeadSelector } from './LeadSelector';
import { useToolbox } from '../hooks/useToolbox';
import { Fragment } from 'react';

export const ZoomNoiseToolbox = () => {
  const tools = useToolbox('zoom-noise');
  return (
    <>
      <HStack justifyContent='space-between' gap='s'>
        <LeadSelector />
        <HStack
          bgColor='neutral.0'
          spacing='xs'
          p='xs'
          borderRadius='4px'
          shadow={400}
        >
          {tools.map((tool, index) => (
            <Fragment key={index}>{tool}</Fragment>
          ))}
        </HStack>
      </HStack>
      <TagFilter />
    </>
  );
};
